import clsx from "clsx";
import React, { FC } from "react";

import { CommonColors } from "../../../types/colors";
import { AppendixCard } from "../../cards/appendix-card";
import { FlatCard } from "../../cards/flat-card";
import { ImageCard } from "../../cards/image-card";
import { MaterialCard } from "../../cards/material-card";
import { ProductCard } from "../../cards/product-card";
import { WhatsNextCard } from "../../cards/whats-next-card";
import { AnimatedSliderItemData, AnimatedSliderProps } from "./animated-slider";
import { AnimatedSliderInnerProps } from "./animated-slider-inner";
import { AnimatedSliderState } from "./types";

export interface AnimatedSliderItemProps
  extends Pick<AnimatedSliderProps, "variant">,
    Pick<AnimatedSliderInnerProps, "animationState"> {
  item: AnimatedSliderItemData;
  visibleCards: number;
  isFullScreen?: boolean;
}

export const AnimatedSliderItem: FC<AnimatedSliderItemProps> = ({
  item,
  variant,
  animationState,
  visibleCards,
  isFullScreen,
}) => {
  const isFinalState = animationState === AnimatedSliderState.FINAL;
  switch (item.__typename) {
    case "ContentfulFlatCard":
      return (
        <FlatCard
          {...item}
          variant={variant === "primary" ? "light" : "dark"}
          showBody={isFinalState}
        />
      );
    case "ContentfulImageCard":
      return (
        <ImageCard
          {...item}
          keepOriginalAspectRatio={false}
          showBody={isFinalState}
          className={clsx(
            isFullScreen && "aspect-[3/4]",
            visibleCards < 3 && "lg:aspect-auto lg:h-136"
          )}
        />
      );
    case "ContentfulMaterialCard":
      return (
        <MaterialCard
          {...item}
          keepAspectRatio={!isFullScreen}
          showBody={isFinalState}
          className={clsx(
            isFullScreen && "aspect-[3/4]",
            visibleCards < 3 && "lg:aspect-auto lg:h-136"
          )}
        />
      );
    case "ContentfulAppendixCard":
      return (
        <AppendixCard
          {...item}
          lineClamp={4}
          className="h-full"
          shadow={animationState === AnimatedSliderState.INITIAL}
        />
      );
    case "ContentfulProduct":
      return <ProductCard product={item} color={CommonColors.Light} hideCtas />;
    case "ContentfulWhatsNext":
      const colorScheme = variant === CommonColors.Primary ? CommonColors.Light : CommonColors.Dark;
      return <WhatsNextCard {...item} colorScheme={colorScheme} showBody={isFinalState} />;
    default:
      console.error("Unknown component", item);
      return null;
  }
};
